import * as React from 'react';
import styled, { StyledFunction, StyledComponentClass } from 'styled-components';
import { breakpoint } from '../../theme/utils/util';
import { theme } from '../../theme/defaultTheme';
import { BreakpointProps } from '../../theme/common/props';

const buttonGroup: StyledFunction<BreakpointProps> = styled.div;

export const StyledButtonGroupDiv = buttonGroup`
  & > * {
    display: block;
    width: 100%;
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }

    ${props => breakpoint(props.theme, props.breakpoint, `
      display: inline-block;
      width: auto;
      margin-right: 24px;
      margin-bottom: 0;

      &:last-child {
        margin-right: 0
      }
    `)}
  }
`;

StyledButtonGroupDiv.defaultProps = {
  theme
};
